import {
	ActivateCategoryMutation,
	AddCategoryMutation,
	BatchActivateCategoriesMutation,
	BatchInactivateCategoriesMutation,
	BatchRemoveCategoriesMutation,
	InactivateCategoryMutation,
	RemoveCategoryMutation,
	RenameCategoryMutation,
	SetCategoryIncomeGlAccountMutation,
	UpdateCategoryMutation
} from "~/gql/mutations/category.generated";
import { GetCategoriesQuery, GetCategoriesWithShippingUomQuery } from "~/gql/queries/category.generated";
import { GetCategoryUsedByQuery } from "~/gql/queries/usedBy.generated";

export const categoryEndpoints = {
	ActivateCategory: {
		invalidatesTags: ["Category"] as AddTagTypes,
		transformResponse: (res: ActivateCategoryMutation) => res
	},
	AddCategory: {
		invalidatesTags: ["Category", "RevenueRoutingCoverage"] as AddTagTypes,
		transformResponse: (res: AddCategoryMutation) => res
	},
	BatchActivateCategories: {
		invalidatesTags: ["Category"] as AddTagTypes,
		transformResponse: (res: BatchActivateCategoriesMutation) => res
	},
	BatchInactivateCategories: {
		invalidatesTags: ["Category"] as AddTagTypes,
		transformResponse: (res: BatchInactivateCategoriesMutation) => res
	},
	BatchRemoveCategories: {
		invalidatesTags: ["Category", "RevenueRoutingCoverage"] as AddTagTypes,
		transformResponse: (res: BatchRemoveCategoriesMutation) => res
	},
	GetCategories: {
		providesTags: ["Category"] as AddTagTypes,
		transformResponse: (res: GetCategoriesQuery) => res
	},
	GetCategoryUsedBy: {
		providesTags: ["Category"] as AddTagTypes,
		transformResponse: (res: GetCategoryUsedByQuery) => res
	},
	GetCategoriesWithShippingUom: {
		providesTags: ["Category"] as AddTagTypes,
		transformResponse: (res: GetCategoriesWithShippingUomQuery) => res
	},
	InactivateCategory: {
		invalidatesTags: ["Category"] as AddTagTypes,
		transformResponse: (res: InactivateCategoryMutation) => res
	},
	RemoveCategory: {
		invalidatesTags: ["Category", "RevenueRoutingCoverage"] as AddTagTypes,
		transformResponse: (res: RemoveCategoryMutation) => res
	},
	RenameCategory: {
		invalidatesTags: ["Category", "Items", "Price"] as AddTagTypes,
		transformResponse: (res: RenameCategoryMutation) => res
	},
	SetCategoryIncomeGlAccount: {
		invalidatesTags: ["Category", "RevenueRoutingCoverage"] as AddTagTypes,
		transformResponse: (res: SetCategoryIncomeGlAccountMutation) => res
	},
	UpdateCategory: {
		invalidatesTags: ["Category"] as AddTagTypes,
		transformResponse: (res: UpdateCategoryMutation) => res
	}
};
